import React from 'react';

const AlertIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1544 3.36311C11.5468 2.74177 12.453 2.74177 12.8454 3.36311L23.4205 20.1071C23.8411 20.773 23.3626 21.6411 22.5751 21.6411H1.42474C0.637185 21.6411 0.158703 20.773 0.579252 20.1071L11.1544 3.36311Z"
      fill="#0073F7"
      fillOpacity="0.16"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1344 9.29924C11.1156 8.80823 11.5085 8.3999 11.9999 8.3999C12.4913 8.3999 12.8842 8.80823 12.8654 9.29924L12.5999 16.2124H11.3999L11.1344 9.29924ZM11.3999 18.5999V17.3999H12.5999V18.5999H11.3999Z"
      fill="#0073F7"
    />
  </svg>
);

export default AlertIcon;
